import { Box, Skeleton, useMediaQuery } from "@mui/material";
import { useGlobalTheme } from "../context/GlobalThemeContext";

const ChatLoadingFallback = () => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const isDark = useGlobalTheme();

  const bgMain = isDark ? "#141414" : "#EEEEEF";
  const bgSidebar = isDark ? "rgba(30,30,30,0.95)" : "#e0e0e0";
  const bgChat = isDark ? "rgba(20,20,20,0.98)" : "#fff";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: bgMain,
      }}
    >
      {/* Navbar Skeleton */}
      <Box
        sx={{
          height: { xs: "60px", md: "80px" },
          backgroundColor: "#54398E",
          display: "flex",
          alignItems: "center",
          px: 2,
          gap: 2,
        }}
      >
        <Skeleton
          variant="circular"
          width={40}
          height={40}
          sx={{ bgcolor: "rgba(255,255,255,0.2)" }}
        />
        <Skeleton
          variant="rectangular"
          width={120}
          height={30}
          sx={{ bgcolor: "rgba(255,255,255,0.2)" }}
        />
        <Box flexGrow={1} />
        <Skeleton
          variant="circular"
          width={40}
          height={40}
          sx={{ bgcolor: "rgba(255,255,255,0.2)" }}
        />
      </Box>

      <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
        {/* Sidebar Skeleton */}
        {!isMobile && (
          <Box
            sx={{
              width: "30%",
              backgroundColor: bgSidebar,
              p: 3,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{ borderRadius: 1 }}
            />
            <Box display="flex" gap={1}>
              <Skeleton
                variant="rectangular"
                width="33%"
                height={36}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width="33%"
                height={36}
                sx={{ borderRadius: 1 }}
              />
              <Skeleton
                variant="rectangular"
                width="33%"
                height={36}
                sx={{ borderRadius: 1 }}
              />
            </Box>
            {Array.from({ length: 8 }).map((_, i) => (
              <Box
                key={i}
                display="flex"
                alignItems="center"
                gap={2}
                sx={{
                  animation: `pulse 1.5s ease-in-out ${i * 0.1}s infinite`,
                  "@keyframes pulse": {
                    "0%, 100%": { opacity: 1 },
                    "50%": { opacity: 0.5 },
                  },
                }}
              >
                <Skeleton variant="circular" width={48} height={48} />
                <Box flexGrow={1}>
                  <Skeleton variant="text" width="70%" height={20} />
                  <Skeleton variant="text" width="50%" height={16} />
                </Box>
              </Box>
            ))}
          </Box>
        )}

        {/* Chat area skeleton */}
        <Box
          sx={{
            flex: 1,
            backgroundColor: bgChat,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: "50%",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #54398E",
              animation: "spin 1s linear infinite",
              "@keyframes spin": {
                "0%": { transform: "rotate(0deg)" },
                "100%": { transform: "rotate(360deg)" },
              },
            }}
          />
          <Skeleton variant="text" width={200} height={24} />
        </Box>
      </Box>
    </Box>
  );
};

export default ChatLoadingFallback;
